import { render, staticRenderFns } from "./myTree.vue?vue&type=template&id=2444dc37&scoped=true"
import script from "./myTree.vue?vue&type=script&lang=js"
export * from "./myTree.vue?vue&type=script&lang=js"
import style0 from "./myTree.vue?vue&type=style&index=0&id=2444dc37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2444dc37",
  null
  
)

export default component.exports